import { sbaAxios } from "../utils/sbaAxios";
import { getAssetNotesTabDetail,getAssetNoteDetail} from "../../config/apiConfig";
import {
    FETCH_ASSET_NOTESTAB_DETAILS_BEGIN,
    FETCH_ASSET_NOTESTAB_DETAILS_SUCCESS,
    FETCH_ASSET_NOTESTAB_DETAILS_FAILURE,
    FETCH_ASSET_NOTE_DETAILS_BEGIN,
    FETCH_ASSET_NOTE_DETAILS_SUCCESS,
    FETCH_ASSET_NOTE_DETAILS_FAILURE
  
  } from '../constants/assetNotes';

  export const getAssetNotesTabDetails = (AssetId) => {
    return (dispatch) => {
        dispatch(fetchNotesTabBegin());
        sbaAxios({
            url: `${getAssetNotesTabDetail}${AssetId}`,
            method: 'get',
        })
            .then((repos) => {
                const notesDetails = repos;
                dispatch(fetchNotesTabSuccess(notesDetails));
                return notesDetails;
            })  
            .catch((error) => dispatch(fetchNotesTabFailure(error)));
    };
  }
  export const fetchNotesTabBegin = () => ({
    type: FETCH_ASSET_NOTESTAB_DETAILS_BEGIN,
  });
  
  export const fetchNotesTabSuccess = (notesDetails) => ({
    type: FETCH_ASSET_NOTESTAB_DETAILS_SUCCESS,
    payload: { notesDetails },
  });
  
  
  export const fetchNotesTabFailure = (errorMessage) => ({
    type: FETCH_ASSET_NOTESTAB_DETAILS_FAILURE,
    payload: { errorMessage }
  });


  export const getAssetNoteDetails = (ActivityId) => {
    return (dispatch) => {
        dispatch(fetchNoteBegin());
        sbaAxios({
            url: `${getAssetNoteDetail}${ActivityId}`,
            method: 'get',
        })
            .then((repos) => {
                const notesDetail = repos;
                //Add logic to format the DataItem if needed using map
                dispatch(fetchNoteSuccess(notesDetail));
                return notesDetail;
            })  
            .catch((error) => dispatch(fetchNoteFailure(error)));
    };
  }
  export const fetchNoteBegin = () => ({
    type: FETCH_ASSET_NOTE_DETAILS_BEGIN,
  });
  
  export const fetchNoteSuccess = (notesDetail) => ({
    type: FETCH_ASSET_NOTE_DETAILS_SUCCESS,
    payload: { notesDetail },
  });
  
  
  export const fetchNoteFailure = (errorMessage) => ({
    type: FETCH_ASSET_NOTE_DETAILS_FAILURE,
    payload: { errorMessage }
  });